import { render, staticRenderFns } from "./Reorder.vue?vue&type=template&id=8f881d50"
import script from "./Reorder.vue?vue&type=script&lang=ts"
export * from "./Reorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports